import GeneralServices from "./GeneralServices";
import {
  IGetPersonDataRequest,
  IGetPersonDataResponseOk,
  IResponseError,
  IgetSupplementDocumentsRequestProps,
  IgetSupplementDocumentsResponseOk,
  IgetSupplementsRequest,
  IgetSupplementsResponseOk,
  SendTo,
} from "./SupplementsServices.dto";
import { BasicDataModifications } from "./dto/request/SendBasicDataModificationsEmail.dto";
import { CatchErrorType } from "./dto/response/CommonResponse.dto";
import { getPolicyData } from "./utils";

class SupplementsServices {
  private handleError = (error: unknown, defaultMessage: string): IResponseError => {
    const typedError = error as CatchErrorType;
    const errorMsg = typedError.data && typedError.data.message;
    return {
      ok: false,
      message: typeof errorMsg === "string" ? errorMsg : defaultMessage,
    };
  };

  getSupplements = async (
    args: IgetSupplementsRequest
  ): Promise<IgetSupplementsResponseOk | IResponseError> => {
    const { subramo, setLoading, loader, collective, businessGroup } = args;
    // reemplazo los '/' por '-' porq sino modifica el endpoint y da un 404. 
    // Si se añade algún nuevo subramo que lleve '/' recordar que en bbdd se añade como '-'
    // Ejemplo: 'ASISA PREVISION/HOSPITALIZACION' en bbdd está cómo: 'ASISA PREVISION-HOSPITALIZACION'
    const finalSubramo = subramo.includes('/') ? subramo.replace('/', '-') : subramo;
    try {
        const response = await GeneralServices.get({
          setLoading: setLoading,
          loader: loader === false ? false : true,
          endpoint: `supplements/${collective}/${businessGroup}/${finalSubramo}`,
        });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de la lista de suplementos.");
    }
  };

  sendNewInsuranceEmail = async (data: any) => {
    const formData = new FormData();
    if (data.documents && data.documents.uploadDocuments) {
      data.documents.uploadDocuments.forEach((doc: {type: string, description: string, file: File}) => {
        if (doc.file && doc.file instanceof File) {
          formData.append('files', doc.file, doc.file.name);
        }
      });
    }
  
    formData.append('taker', JSON.stringify(data.taker));
    formData.append('policyData', JSON.stringify(getPolicyData()));
    formData.append('address', JSON.stringify(data.address));
    formData.append('contact', JSON.stringify(data.contact));
    formData.append('guarantees', JSON.stringify(data.guarantees));
    formData.append('documents', JSON.stringify(data.documents));
    formData.append('clinicalData', JSON.stringify(data.clinicalData));
  
    try {
      const response = await GeneralServices.postFormData({
        setLoading: () => {},
        isSlowProcess: true,
        loader: true,
        endpoint: "supplements/upload-new-insurance",
        data: formData,
      });
      return response.data;
    } catch (err) {
      return err;
    }
  };

  sendBasicDataModificationsEmail = async (data: BasicDataModifications, sendTo?: SendTo, isInsuredInSendaPolicy?: boolean) => {
    const formData = new FormData();
    if (data.documents && data.documents.uploadDocuments) {
      data.documents.uploadDocuments.forEach((doc: {type: string, description: string, file: File}) => {
        if (doc.file && doc.file instanceof File) {
          formData.append('files', doc.file, doc.file.name);
        }
      });
    }
  
    formData.append('policyData', JSON.stringify(getPolicyData()));
    formData.append('data', JSON.stringify(data));

    if (sendTo) {
      formData.append('sendTo', JSON.stringify(sendTo));
    }
    if (typeof isInsuredInSendaPolicy === "boolean") {
      formData.append('isInsuredInSendaPolicy', `${isInsuredInSendaPolicy}`);
    }
  
    try {
      const response = await GeneralServices.postFormData({
        setLoading: () => {},
        isSlowProcess: true,
        loader: true,
        endpoint: "supplements/basic-data-modification",
        data: formData,
      });
      return response.data;
    } catch (err) {
      return err;
    }
  };

  getSEPATempleate = async (args: any) => {
      try {
        const response = await GeneralServices.get({
          arraybuffer: args.arraybuffer,
          setLoading: args.setLoading,
          loader: args.loader === false ? false : true,
          endpoint: `files/download-sepa${args.params ? '?' + args.params.join("&") : ''}`,
        });
        return response.data;
      }
      catch (err) {
        return [];
      }
    }

  getRequiredDocuments = async ({
    setLoading,
    loader,
    request,
  }: IgetSupplementDocumentsRequestProps): Promise<IgetSupplementDocumentsResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.post({
        setLoading: setLoading,
        loader: loader === false ? false : true,
        endpoint: `required-documents/supplements`,
        data: request,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de la lista de documentos.");
    }
  };

  getPersonData = async ({ setLoading, loader, docNum, mediatorCode }: IGetPersonDataRequest): Promise<IGetPersonDataResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: loader === true ? true : false,
        endpoint: `supplements/get-customer-policies?docNum=${docNum}&mediatorCode=${mediatorCode}`,
      });
      return {
        ok: true,
        data: response.data,
      }
    } catch (error) {
      return this.handleError(error, "Error en la recuperación de los datos del interviniente");
    }
  }
}
export default new SupplementsServices();
